import dayjs from "dayjs";

type DateType = string | number | dayjs.Dayjs | Date | null | undefined;

const formatDate = (date: DateType) => {
	return dayjs(date).format("DD MMMM YYYY");
};

export default formatDate;
